<div class="help-sidePanel">
  <div class="helpHover">
    <div class="side-tab" (click)="togglePanel('help')">
      <p style="margin-top: 1rem">
        <svg
          id="_icons_search-outline"
          data-name="⚛️ icons/search-outline"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="35"
          height="35"
          viewBox="0 0 50 50"
        >
          <defs>
            <clipPath id="clip-path">
              <rect id="Background" width="50" height="50" fill="#fff" />
            </clipPath>
          </defs>
          <g id="Group_1" data-name="Group 1">
            <g
              id="Mask_Group_1"
              data-name="Mask Group 1"
              clip-path="url(#clip-path)"
            >
              <path
                id="Combined_Shape"
                data-name="Combined Shape"
                d="M37.984,40.193l-.026-.024L27.694,29.9A16.921,16.921,0,1,1,29.9,27.694L40.168,37.958a1.563,1.563,0,0,1-2.184,2.235ZM3.126,16.9A13.778,13.778,0,1,0,16.9,3.126,13.794,13.794,0,0,0,3.126,16.9Z"
                transform="translate(4.688 4.688)"
                fill="#fff"
              />
            </g>
          </g>
        </svg>
      </p>
    </div>
    <span style="left: 70px" class="helpHovertooltip-box">Help Glossary</span>
  </div>
  <div class="side-panel" [class.open]="panelOpen">
    <p class="coverageDashboardHover" (click)="togglePanel('coverage')">
      <br /><svg
        [ngClass]="{ 'on-Top': coverageOpen }"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 22.856 20.753"
      >
        <g id="home-outline" transform="translate(-30.94 -47.267)">
          <path
            id="Path_811"
            data-name="Path 811"
            d="M80,212v10.923a.741.741,0,0,0,.741.741h4.443v-6.295a1.111,1.111,0,0,1,1.111-1.111H90a1.111,1.111,0,0,1,1.111,1.111v6.295h4.443a.741.741,0,0,0,.741-.741V212"
            transform="translate(-45.778 -156.393)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          />
          <path
            id="Path_812"
            data-name="Path 812"
            d="M52.735,57.644,42.872,48.2a.781.781,0,0,0-1.008,0L32,57.644M49.033,54.08V48.757H46.811v3.194"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          />
        </g>
      </svg>
      @if (!coverageOpen) {
      <span class="coveragetooltip-box" style="top: 295px"
        >Coverage Dashboard</span
      >
      }
    </p>
    @if (coverageOpen) {
    <div>
      <p
        class="top-tab"
        [class.open]="coverageOpen"
        style="top: 289px; padding-right: 50px"
      >
        <b>Coverage Dashboard</b>
      </p>
      <p
        class="top-emptyBox"
        [class.open]="coverageOpen"
        style="top: 279px"
      ></p>
      <p class="coverage-panel" [class.open]="coverageOpen" style="top: 289px">
        The Coverage Dashboard shows <b>coverage type and dates</b> for each
        member, and details such as their
        <b
          >full name, age, gender, health plan name, address, phone number, and
          Assisting Person name.</b
        ><br /><br />
      </p>
    </div>
    }
    <p class="submissionStatusboardHover" (click)="togglePanel('submission')">
      <svg
        [ngClass]="{ 'on-Top': submissionStatusOpen }"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 20.25 20.25"
      >
        <g
          id="chevron-forward-circle-outline"
          transform="translate(-63.375 -63.375)"
        >
          <path
            id="Path_814"
            data-name="Path 814"
            d="M64,73.5A9.5,9.5,0,1,0,73.5,64,9.5,9.5,0,0,0,64,73.5Z"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.25"
          />
          <path
            id="Path_815"
            data-name="Path 815"
            d="M216,169.5l4.75-4.75L216,160"
            transform="translate(-144.479 -91.25)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.25"
          />
        </g>
      </svg>
      @if (!submissionStatusOpen) {
      <span class="submissionStatustooltip-box" style="top: 335px"
        >Submission Status</span
      >
      }
    </p>
    @if (submissionStatusOpen) {
    <div>
      <p class="top-tab" [class.open]="submissionStatusOpen" style="top: 333px">
        <b>Submission Status</b>
      </p>
      <p
        class="top-emptyBox"
        [class.open]="submissionStatusOpen"
        style="top: 323px"
      ></p>
      <p
        class="coverage-panel"
        [class.open]="submissionStatusOpen"
        style="top: 333px"
      >
        Submission Status allows members to track the status of applications,
        changes, and renewals. They can see details such as the user's
        <b>full name, email address,</b> and <b>application tracking numbers.</b
        ><br /><br />
      </p>
    </div>
    }
    <p class="applicationFlowsHover" (click)="togglePanel('application')">
      <svg
        [ngClass]="{ 'on-Top': applicationFlowOpen }"
        id="_icons_create-outline"
        data-name="⚛️ icons/create-outline"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 24 24"
      >
        <path
          id="Combined_Shape"
          data-name="Combined Shape"
          d="M2.625,19.5A2.626,2.626,0,0,1,0,16.918V5.625A2.624,2.624,0,0,1,2.581,3h7.895a.75.75,0,0,1,.014,1.5H2.625A1.125,1.125,0,0,0,1.5,5.606V16.875A1.125,1.125,0,0,0,2.606,18H13.875A1.123,1.123,0,0,0,15,16.9V8.25a.75.75,0,0,1,1.5-.015v8.64A2.624,2.624,0,0,1,13.905,19.5H2.625Zm4.928-7.553a.181.181,0,0,1-.046-.182L7.9,10.6a.413.413,0,0,1,.108-.185l8.462-8.446a.421.421,0,0,1,.6,0l.466.468a.422.422,0,0,1,0,.594L9.085,11.494A.427.427,0,0,1,8.9,11.6l-1.165.392A.188.188,0,0,1,7.683,12,.182.182,0,0,1,7.554,11.948ZM18.173,1.858l-.531-.531a.374.374,0,0,1,0-.53l.58-.577A.751.751,0,1,1,19.27,1.3l-.565.563a.375.375,0,0,1-.532,0Z"
          transform="translate(2.25 2.25)"
          fill="#fff"
        />
      </svg>
      @if (!applicationFlowOpen) {
      <span class="applicationFlowtooltip-box" style="top: 380px"
        >Application Flows</span
      >
      }
    </p>
    @if (applicationFlowOpen) {
    <div>
      <p class="top-tab" [class.open]="applicationFlowOpen" style="top: 380px">
        <b>Application Flows</b>
      </p>
      <p
        class="top-emptyBox"
        [class.open]="applicationFlowOpen"
        style="top: 370px"
      ></p>
      <p
        class="coverage-panel"
        [class.open]="applicationFlowOpen"
        style="top: 380px"
      >
        The Application Flows allow members to <b>Apply for Coverage</b> or
        view/change information they already shared in the
        <b>Renew My Benefits, Report A Change,</b>or
        <b>Questions for Review</b> flows. For new applications, some
        information could be pre-filled from One-DHS.<br /><br />
        This includes details such as <b>full names</b> of case members,
        <b
          >address, phone numbers, age, gender, citizenship and immigration
          details, relationships, Assisting Person name and contact information,
          other health insurance details, tax filing status and dependents,
          income sources and details, responses to health related questions,
          expenses,</b
        >
        and <b>financial resources.</b> <br /><br />
      </p>
    </div>
    }
    <p class="healthPlanDetailsHover" (click)="togglePanel('healthPlan')">
      <svg
        [ngClass]="{ 'on-Top': healthPlanDetailsOpen }"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 24.5 22.267"
      >
        <g
          id="medkit-outline_1_"
          data-name="medkit-outline (1)"
          transform="translate(-31.25 -47.25)"
        >
          <rect
            id="Rectangle_1525"
            data-name="Rectangle 1525"
            width="23"
            height="17"
            rx="8.5"
            transform="translate(32 51.767)"
            fill="none"
            stroke="#f1f1f2"
            stroke-width="1.5"
          />
          <path
            id="Path_813"
            data-name="Path 813"
            d="M144,51.242V49.621A1.621,1.621,0,0,1,145.621,48h8.105a1.621,1.621,0,0,1,1.621,1.621v1.621m-5.674,4.863v8.105m4.053-4.053h-8.105"
            transform="translate(-106.326)"
            fill="none"
            stroke="#f1f1f2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          />
        </g>
      </svg>
      @if (!healthPlanDetailsOpen) {
      <span class="healthPlanDetailstooltip-box" style="top: 425px"
        >Health Plan Details</span
      >
      }
    </p>
    @if (healthPlanDetailsOpen) {
    <div>
      <p
        class="top-tab"
        [class.open]="healthPlanDetailsOpen"
        style="top: 425px"
      >
        <b>Health Plan Details</b>
      </p>
      <p
        class="top-emptyBox"
        [class.open]="healthPlanDetailsOpen"
        style="top: 415px"
      ></p>
      <p
        class="coverage-panel"
        [class.open]="healthPlanDetailsOpen"
        style="top: 425px"
      >
        Health Plan Details allow members to see their health plan information.
        This includes members'
        <b
          >full names, health plan start/end dates, requested health plan
          changes, and date of change.</b
        >
        They can also request to change their health plan. <br /><br />
      </p>
    </div>
    }
    <p class="householdDocumentsHover" (click)="togglePanel('household')">
      <svg
        [ngClass]="{ 'on-Top': houseHoldOpen }"
        id="_icons_document-text-outline"
        data-name="⚛️ icons/document-text-outline"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 24 24"
      >
        <path
          id="Combined_Shape"
          data-name="Combined Shape"
          d="M3,21a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0h4.63A2.265,2.265,0,0,1,9.22.659L15.841,7.28A2.236,2.236,0,0,1,16.5,8.871V18a3,3,0,0,1-3,3ZM1.5,3V18A1.5,1.5,0,0,0,3,19.5H13.5A1.5,1.5,0,0,0,15,18V9H9.75A2.249,2.249,0,0,1,7.5,6.787V1.5H3A1.5,1.5,0,0,0,1.5,3ZM9,6.75a.75.75,0,0,0,.735.75h4.2L9,2.561Zm3,9.75H4.5A.75.75,0,0,1,4.486,15H12a.75.75,0,0,1,.015,1.5Zm0-3.749H4.5a.75.75,0,0,1-.014-1.5H12a.75.75,0,0,1,.015,1.5Z"
          transform="translate(3.75 1.5)"
          fill="#fff"
        />
      </svg>
      @if (!houseHoldOpen) {
      <span class="houseHoldtooltip-box" style="top: 470px"
        >Household Documents</span
      >
      }
    </p>
    @if (houseHoldOpen) {
    <div>
      <p
        class="top-tab"
        [class.open]="houseHoldOpen"
        style="top: 470px; padding-right: 30px"
      >
        <b>Household Documents</b>
      </p>
      <p
        class="top-emptyBox"
        [class.open]="houseHoldOpen"
        style="top: 460px"
      ></p>
      <p class="coverage-panel" [class.open]="houseHoldOpen" style="top: 470px">
        <b>My Documents</b> allows members to see <b>uploaded documents</b> and
        a list of documents on their case. This could include
        <b>identifying information, medical, and financial documents.</b
        ><br /><br />
        <b>My Letters</b> allows members to see their eligibility, renewal,
        eligibility appeals, and Long-Term Services & Supports (LTSS) letters.
        Letters include members' <b>full names, ages, client IDs,</b> and
        <b>coverage details.</b><br /><br />
        <b>My Submissions</b> shows applications, renewals, or changes the
        member submitted.This includes details such as <b>full names</b> of case
        members,<b>
          addresses, phone numbers, dates of birth, gender, citizenship and
          immigration details, relationships, Assisting Person name and contact
          information,</b
        >
        other
        <b
          >health insurance details, tax filing status and dependents, income
          sources and details,</b
        >
        responses to <b>health related questions, expenses,</b> and
        <b>financial resources.</b><br /><br />
      </p>
    </div>
    }
    <p class="accountManagementHover" (click)="togglePanel('manageAccount')">
      <svg
        [ngClass]="{ 'on-Top': accountManagement }"
        id="_icons_person-circle-outline"
        data-name="⚛️ icons/person-circle-outline"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 24 24"
      >
        <path
          id="Combined_Shape"
          data-name="Combined Shape"
          d="M9.615,19.5a9.745,9.745,0,0,1-6.8-16.594A9.68,9.68,0,0,1,9.753,0h.133a9.747,9.747,0,0,1,6.8,16.6A9.681,9.681,0,0,1,9.751,19.5Zm4.394-5.563a5.818,5.818,0,0,1,1.517,1.388.186.186,0,0,0,.14.075h.009a.186.186,0,0,0,.139-.06A8.245,8.245,0,0,0,9.752,1.5H9.731A8.244,8.244,0,0,0,3.689,15.341a.186.186,0,0,0,.136.059h.012a.185.185,0,0,0,.14-.075,5.8,5.8,0,0,1,1.517-1.387,7.954,7.954,0,0,1,4.257-1.187A7.955,7.955,0,0,1,14.009,13.938ZM6.574,7.911a3.189,3.189,0,1,1,6.355,0,3.462,3.462,0,0,1-3.178,3.339A3.46,3.46,0,0,1,6.574,7.911Z"
          transform="translate(2.249 2.249)"
          fill="#fff"
        />
      </svg>
      @if (!accountManagement) {
      <span class="accountManagementtooltip-box" style="top: 520px"
        >Account Management</span
      >
      }
    </p>
    @if (accountManagement) {
    <div>
      <p
        class="top-tab"
        [class.open]="accountManagement"
        style="top: 518px; padding-right: 40px"
      >
        <b>Account Management</b>
      </p>
      <p
        class="top-emptyBox"
        [class.open]="accountManagement"
        style="top: 508px"
      ></p>
      <p
        class="coverage-panel"
        [class.open]="accountManagement"
        style="top: 518px"
      >
        <b>Account Management</b> allows members to see the user's
        <b>full name, email address,</b> and <b>username</b> and make changes to
        their <b>email address, phone number, communication preferences,</b> and
        <b>security questions.</b><br /><br />
      </p>
    </div>
    }
  </div>
</div>